import type { Edl, Item } from './edl';

/** id prefix per item type — keeps ids human-debuggable. */
const PREFIX: Record<Item['type'], string> = {
  clip: 'clip',
  caption: 'cap',
  transition: 'trans',
  sfx: 'sfx',
  gif: 'gif',
};

/**
 * Deterministic id generation.
 *
 * id = `${prefix}-${edl.seq}` where `seq` is the EDL's monotonic counter.
 * This is fully deterministic: the same command sequence applied to the same
 * starting EDL always yields identical ids (and therefore a byte-identical EDL).
 * NO `Math.random` / `Date.now` — those would break determinism and replay.
 *
 * Returns the new id plus the next seq value the caller must write back onto
 * the EDL (the reducer threads this through immutably).
 */
export function nextId(edl: Edl, type: Item['type']): { id: string; seq: number } {
  return { id: `${PREFIX[type]}-${edl.seq}`, seq: edl.seq + 1 };
}
